import { Template } from "../../../../../core/template/index";
import { FortumApp } from "../../../../fortumApp";
import { ScannedItemView } from "../../scan_packages/scanned_item";
import { splitItemCode } from "../../../../helpers";


export class DeliveriesListItemView extends ScannedItemView {

    app: FortumApp;
    template = Template.lazy('/app/views/package_tracking/list/item/index.html');

    firstRender: boolean = true;
    itemDescription: HTMLElement;
    itemNumber: HTMLElement;
    packageState: HTMLElement;
    PackageTranspointationUnit: HTMLElement;

    public updateItemData(data)
    {
        console.log(data);
        this.element.classList.add('success');
        this.element.classList.remove('loading');
        this.itemDescription.textContent = data.item_description;
        this.itemNumber.textContent = data.item;

        this.getPacketStateText(data.state);
        this.getTransportationUnitName(data.tup_id);

        this.item = Object.assign({}, data);
    }

    private getTransportationUnitName(tupId) {
        this.app.db.TransportationUnit.get(tupId).then(tup => {
            if (tup) {
                this.PackageTranspointationUnit.textContent = tup.name;
            } else {
                // Local data not available, go to network
                const tup = this.app.api.private('pt_transportation_unit_info', {package_tag: tupId});
            }
        }).catch(() => {
            this.PackageTranspointationUnit.textContent = '';
        });
    }

    private getPacketStateText(state) {
        switch (state) {
            case 'note_received':
                this.packageState.classList.add('pt-package-state-note-received');
                this.packageState.textContent = this.pgettext('PackageTracking.PacketState', 'Note received')
                break;
            case 'received':
                this.packageState.classList.add('pt-package-state-received');
                this.packageState.textContent = this.pgettext('PackageTracking.PacketState', 'Received')
                break;
            case 'ready_for_delivery':
                this.packageState.classList.add('pt-package-state-ready-for-delivery');
                this.packageState.textContent = this.pgettext('PackageTracking.PacketState', 'Ready for delivery')
                break;
            case 'in_delivery':
                this.packageState.classList.add('pt-package-state-in-delivery');
                this.packageState.textContent = this.pgettext('PackageTracking.PacketState', 'In delivery')
                break;
            case 'delivered':
            default:
                this.packageState.classList.add('pt-package-state-delivered');
                this.packageState.textContent = this.pgettext('PackageTracking.PacketState', 'Delivered')
                break;
            
        }
    }

    public render(to: HTMLElement) {
        if (this.firstRender) {
            this.firstRender = false;
        } else {
            this.element.classList.remove('success');
        }
        to.insertAdjacentElement('beforeend', this.element);
    }

    protected constructItem(data) {
        this.dataLoader = this.app.db.DeliveryNoteItem.get(data.delivery_note_item_id).then(item => {
            if (item) {
                let itemObj: any = item;
                itemObj.state = data.state;
                itemObj.tup_id = data.transportation_unit_id
                return itemObj;
            } else {
                // Local data not available, go to network
                return this.app.api.private('pt_delivery_note_item_info', {package_tag: data.delivery_note_item_id});
            }
        });
    }

    public onDeleteClick() {
        this.trigger('delete', this);
    }

    protected onDataLoadedSuccessfully(data: any) {
        this.updateItemData(data);
    }
    
    protected onDataLoadError(error: any) {
        this.app.toasts.show(this.pgettext('Message', 'Delivery item not found!'));
    }

}